import { createContext, SyntheticEvent, useContext } from 'react';
import { CommonFieldProps } from '@cld/common-definitions';

type RadioGroupContextType = CommonFieldProps<string, SyntheticEvent<HTMLInputElement>>;

export const RadioGroupContext = createContext<RadioGroupContextType | undefined>(undefined);

export const useRadioGroupContext = () => {
  const contextValue = useContext(RadioGroupContext);

  if (contextValue === undefined) {
    throw new Error('You can not use RadioGroup.Radio component outside RadioGroup');
  }

  return contextValue;
};
